import keyBy from 'lodash/keyBy';
import { flattenTree } from 'components/base/MultiLevelDropdown/MultiLevelDropdown.utils';

export const getTreeTeamsContributors = ({ teams = [], contributors }) => {
  if (teams.length === 0) {
    return contributors;
  }

  const contributorsById = keyBy(contributors, 'id');
  const contributorsIds = new Set();

  teams.forEach(team => {
    const flatSelectedTreeTeam = flattenTree([team], 'children');
    const selectedTeamContributorsIds = flatSelectedTreeTeam.flatMap(
      ({ contributor_ids }) => contributor_ids
    );
    selectedTeamContributorsIds.forEach(id => contributorsIds.add(id));
  });

  return [...contributorsIds].map(id => contributorsById[id]).filter(Boolean);
};
